import Marionette from "../../../shared/marionette-mustache";
import { LegislationRelationModel } from "../../../desktop/models/legislation-relation";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

const template = require<string>("../../../desktop/views/partials/amended-item-relation.html");

@backboneViewProperties({
    template,
    tagName : "div"
})
export class AmendedItemRelationView extends Marionette.ItemView<LegislationRelationModel> {
    constructor(options?: Backbone.ViewOptions<LegislationRelationModel>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/amended-item-relation.ts